import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import Swal from 'sweetalert2';

export default function PaymentFormModal({ show, onClose, plan = {}, profile = {} }) {
    const [formData, setFormData] = useState({
        cardNumber: "",
        paymentMethod: "Credit Card",
        address: "",
        phone: "",
    });

    if (!show) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Only allow digits in card number & phone
        if (name === "cardNumber") {
            // allow up to 16 digits only
            if (!/^\d*$/.test(value)) return;
            if (value.length > 16) return;
        }

        if (name === "phone") {
            // allow only digits and up to 15 digits
            if (!/^\d*$/.test(value)) return;
            if (value.length > 15) return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.cardNumber.length < 13 || formData.cardNumber.length > 16) {
            alert("❌ Invalid card number! It must be between 13 and 16 digits.");
            return;
        }

        if (formData.phone.length < 7 || formData.phone.length > 15) {
            alert("❌ Invalid phone number! Please enter a valid number.");
            return;
        }

        const payload = {
            profileName: profile?.name || "Unknown User",
            selectedPlan: plan?.name || "Unknown Plan",
            cardNumber: formData.cardNumber,
            paymentMethod: formData.paymentMethod,
            address: formData.address,
            phone: formData.phone,
        };

        console.log("📤 Sending Payment Data:", payload);

        try {
            const response = await fetch("http://localhost:8000/payment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error("Payment failed");

            const data = await response.json();
            // alert(`✅ Payment successful for ${data.plan_name || plan.name}!`);
            Swal.fire({
                icon: 'success',
                title: '✅ Payment Successful!',
                html: `Payment successful for <b>${data.plan_name || plan.name}</b>! 
         <span style="color:green; font-weight:bold;">${profile?.name}</span> is coming for you soon.`,
                // text: `Payment successful for ${data.plan_name || plan.name}! & ${profile?.name} is coming for you soon.`,
                confirmButtonText: 'OK',
            });
            onClose();
        } catch (error) {
            // alert("❌ Payment failed. Try again.");
            Swal.fire({
                icon: 'error',
                title: '❌ Payment Failed',
                text: 'Try again.',
                confirmButtonText: 'OK',
            });
            console.error(error);
        }
    };

    return (
        <div
            className="modal fade show"
            style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 1060,
            }}
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content border-0 rounded-4 shadow">
                    <div className="modal-header border-0">
                        <h5 className="modal-title">
                            Complete Payment for {plan?.name}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            {/* Card Number */}
                            <div className="mb-3">
                                <label className="form-label">Card Number</label>
                                <input
                                    type="text"
                                    name="cardNumber"
                                    inputMode="numeric"
                                    className="form-control"
                                    placeholder="1234 5678 9012 3456"
                                    value={formData.cardNumber}
                                    onChange={handleChange}
                                    required
                                />
                                <small className="text-muted">Only digits allowed (13–16 digits)</small>
                            </div>

                            {/* Payment Method */}
                            <div className="mb-3">
                                <label className="form-label">Payment Method</label>
                                <select
                                    name="paymentMethod"
                                    className="form-select"
                                    value={formData.paymentMethod}
                                    onChange={handleChange}
                                >
                                    <option>Credit Card</option>
                                    <option>Debit Card</option>
                                    <option>PayPal</option>
                                    <option>UPI</option>
                                </select>
                            </div>

                            {/* Address */}
                            <div className="mb-3">
                                <label className="form-label">Billing Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    className="form-control"
                                    placeholder="Enter your address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Phone */}
                            <div className="mb-3">
                                <label className="form-label">Phone Number</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    inputMode="numeric"
                                    className="form-control"
                                    placeholder="923001234567"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                                <small className="text-muted">Only digits allowed (7–15 digits)</small>
                            </div>

                            <button type="submit" className="btn payment-btn w-100">
                                Pay {plan?.price}
                            </button>
                        </form>
                    </div>

                    <div className="modal-footer mb-1 pt-0 border-0">
                        <button className="btn btn-secondary w-100" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
